import { Injectable } from '@angular/core';
import {
  IOnboardingParams,
  IOnboardingParamsWithoutFormat,
} from '../../../core/models/onboarding.model';
import { UtilService } from '@app/services/util.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private _utilService: UtilService) {}

  private _formatDate(date: string): string {
    if (!date) return '';

    const dateParts = date.split('-');
    const year = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]);
    const day = parseInt(dateParts[2]);

    if (isNaN(year) || isNaN(month) || isNaN(day)) return '';

    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    return `${formattedDay}/${formattedMonth}/${year}`;
  }

  public buildCustomerInfo(stepInfo: IOnboardingParamsWithoutFormat): IOnboardingParams {
    const {
      first_name,
      middle_name,
      first_surname,
      second_surname,
      identification_number,
      identification_expedition_at,
      occupation,
      email,
      email_confirmation,
      civil_status,
      spouse_name,
      spouse_surname,
      accept_processing_of_personal_data,
      accept_personal_data_for_commercial_purposes,
      blocked_by_multiple_attempts,
    } = stepInfo || {};

    const slashFormatDate = this._formatDate(identification_expedition_at);
    const mappedCivilStatus =
      this._utilService.civilStatusMappingENtoES(civil_status) || civil_status;

    return {
      firstName: first_name,
      middleName: middle_name,
      firstSurname: first_surname,
      secondSurname: second_surname,
      identificationNumber: identification_number,
      identificationExpeditionAt: slashFormatDate,
      occupation: occupation,
      email,
      emailConfirmation: email_confirmation,
      civilStatus: mappedCivilStatus,
      spouseName: spouse_name,
      spouseSurname: spouse_surname,
      acceptProcessingOfPersonalData: accept_processing_of_personal_data,
      acceptPersonalDataForCommercialPurposes: accept_personal_data_for_commercial_purposes,
      blocked_by_multiple_attempts: blocked_by_multiple_attempts,
    };
  }
}
